<template>
  <div class="check-in">
    <payDialog
      title="修护登记确认"
      :bizType="'pay'"
      :hide="dialogHide"
      :mobile="form.mobile"
      @changeDialog="savePay"
    ></payDialog>
    <el-dialog
      class="search-dialog"
      :visible.sync="memberSearchHide"
      width="800px"
      style="z-index:9999;"
      title="选择会员"
    >
      <div class="p10">
        <el-input
          placeholder="输入客户手机号、编号或姓名"
          v-model="memberMsg"
          clearable
          @clear="clearMember"
          class="input-with-select"
          prefix-icon="el-icon-search"
        >
          <el-button type="primary" slot="append" @click="selectMember">搜索会员</el-button>
        </el-input>
        <div class="member-box" v-if="memberHide">
          <div class="list" v-if="list">
            <div class="flex-row p10" @click="clickMember(list)">
              <el-avatar :src="list.headImgUrl" v-if="list.headImgUrl"></el-avatar>
              <el-avatar :src="headImg" v-else></el-avatar>
              <div class="msg ml10">
                <p>{{ list.mobile }} ({{ list.nickName }})</p>
                <p>账户余额: {{ list.walletAmount }}</p>
              </div>
            </div>
          </div>
          <div class v-else>没有此会员信息</div>
        </div>
        <div class="p10 mt10 memberMsg" v-if="memberMsgHide">
          <div class="flex-row">
            <p>姓名</p>
            <p>{{ list.nickName }}</p>
          </div>
          <div class="flex-row">
            <p>手机号码</p>
            <p>{{ list.mobile }}</p>
          </div>
          <div class="flex-row">
            <p>会员号</p>
            <p>{{ list.memberNo }}</p>
          </div>
          <div class="flex-row">
            <p>修护卡编号</p>
            <p>{{ form.id }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="memberMsgHide">
        <el-button class="large-btn" @click="dialogclose">取 消</el-button>
        <el-button class="large-btn" type="primary" @click="dialogconfig">确 定</el-button>
      </span>
    </el-dialog>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="totals-box">
            <div class="boxs shop-boxs">
              <div class="rows">
                <p class="name">建档门店</p>
                <p>{{ form.shopIdCn }}</p>
              </div>
            </div>
            <div class="boxs">
              <div class="rows">
                <p class="name">顾客姓名</p>
                <p>{{ form.customerName }}</p>
              </div>
              <div class="rows">
                <p class="name">顾客手机号</p>
                <p>{{ form.mobile }}</p>
              </div>

              <div class="rows">
                <p class="name">建档技师</p>
                <p>{{ form.staffIdCn }}</p>
              </div>
              <div class="rows">
                <p class="name">修护金额</p>
                <p class="money">{{ form.amount ? '￥'+form.amount: '---'}}</p>
              </div>
              <div class="rows">
                <p class="name">分类及个数</p>
                <div>{{ form.symptom }}</div>
              </div>
              <div class="rows">
                <p class="name">原始备注</p>
                <div>{{ form.remark }}</div>
              </div>
              <div class="rows">
                <p class="name">修护状态</p>
                <div class="active">{{ form.repairStatusCn }}</div>
              </div>
              <div class="rows">
                <p class="name">下次修护时间</p>
                <div class="active">{{ formatDay(form.nextRepairTime) }}</div>
              </div>
              <div class="rows">
                <p class="name">过期时间</p>
                <div class="active">{{ formatDay(form.validEndTime) }}</div>
              </div>
            </div>
          </div>
          <div class="repair-box">
            <div>
              <div v-for="(item,index) in form.recordList" :key="index" class="repair-msg">
                <div class="top">
                  <p class="date">{{ formatDay(item.repairTime) }}</p>
                  <p
                    class="status"
                    :class="item.auditStatus == 'pass'?'time':'status'"
                  >{{ item.auditStatusCn }}</p>
                </div>
                <div class="top">
                  <p>修护门店</p>
                  <p>{{ item.shopIdCn }}</p>
                </div>
                <div class="top">
                  <p>修护技师</p>
                  <p>{{ item.staffIdCn }}</p>
                </div>
                <div class="center-mains">
                  <div class="imgs">
                    <p class="imgs-name">修护照片</p>
                    <div class="img-list">
                      <el-image
                        class="img"
                        v-for="(i,j) in item.imgUrlList"
                        :key="j"
                        :src="i"
                        title="点击放大图片"
                        :preview-src-list="item.imgUrlList"
                      ></el-image>
                    </div>
                  </div>
                  <div class="rows remarks-box">
                    <div class="remark">备注信息</div>
                    <el-input class="text-area" type="textarea" v-model="item.remak"></el-input>
                  </div>
                  <div class="rows remarks-box" v-if="item.auditStatus == 'refuse'">
                    <div class="remark">审核备注</div>
                    <el-input class="text-area" type="textarea" v-model="item.auditRemark"></el-input>
                  </div>
                  <div class="rows" v-if="item.auditStatus == 'refuse'">
                    <div></div>
                    <el-button
                      type="primary"
                      class="large-btn"
                      plain
                      size="mini"
                      @click="anewSubmit(item)"
                    >重新提交</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="back el-icon-back" @click="back"></div>
          <div class="btns">
            <el-button
              type="primary"
              class="large-btn"
              @click="bandMemberCard"
              v-if="form.repairOrigin == 'paper' && form.memberId == null"
            >绑定会员卡</el-button>
            <el-button
              type="danger"
              v-if="form.repairStatus == 'handle'"
              class="small-btn"
              @click="saveMoney"
            >修护登记</el-button>
            <el-button
              type="primary"
              class="small-btn"
              @click="refundClick(form)"
              v-if=" form.repairOrigin == 'merchantapp' && form.repairStatus == 'handle' && $store.getters.ShopInfo.shopId == form.shopId"
            >申请退款</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <staff-set ref="staffSetForm" @staffChange="changePage"></staff-set>
    <handle-edit ref="handleEditForm" @change="editChange"></handle-edit>
    <refund-set ref="editSetForm" @change="handleChange"></refund-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import member from "../../components/member";
import payDialog from "../../components/pay-dialog";
import staffSet from "../../components/staff-set";
import handleEdit from "./handle-edit";
import refundSet from "./refund-set";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: {
    member,
    payDialog,
    staffSet,
    drawer,
    handleEdit,
    refundSet
  },
  data() {
    return {
      addEditTitle: "登记信息",
      addEditShow: false,
      dialogHide: false,
      memberSearchHide: false,
      isPayWayHide: true,
      form: {
        recordList: []
      },
      status: 1,
      repairForm: {
        imgUrlList: [],
        remark: "",
        staffId: "",
        repairDocumentId: "",
        nextRepairTime: "" //new Date(),//下次修护时间
      },
      staffNames: "",
      options: [],
      memberMsg: "",
      memberHide: false,
      list: {},
      memberMsgHide: false,
      shopImg: require("../../../assets/images/shop.png"),
      queryId: "",
      headImg:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
    };
  },
  created() {
    // this.handleInit();
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    editChange() {
      /*
                TODO 不知道干啥用的，淦！
            */
    },
    refundClick(row) {
      this.$refs["editSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      this.addEditShow = false;
    },
    back() {
      this.addEditShow = false;
    },
    handleInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.queryId = org.id;
        this.$api
          .get(this.$url.repairDocument.get, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.form = res;
              this.repairForm.repairDocumentId = this.form.id;
              // this.form.memberId = null;
            }
          });
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        single: true,
        staffIds: this.repairForm.staffId,
        index: 0
      });
    },
    changePage(org) {
      this.repairForm.staffId = org.staffIds[0].staffId;
      this.staffNames = org.staffIds[0].staffName;
    },
    gotoCenter() {
      this.$router.push("/collectMoney/center");
    },
    clearMember() {
      this.memberMsg = "";
      this.list = {};
      this.memberHide = false;
      this.memberMsgHide = false;
    },
    clickMember(list) {
      this.memberHide = false;
      this.memberMsgHide = true;
    },
    dialogclose() {
      this.memberMsg = "";
      this.memberMsgHide = false;
      this.memberSearchHide = false;
      this.list = {};
    },
    dialogconfig() {
      this.$api
        .get(this.$url.repairDocument.bindMember, {
          docId: this.form.id,
          memberId: this.list.id
        })
        .then(res => {
          if (res) {
            this.memberSearchHide = false;

            this.$api
              .get(this.$url.repairDocument.get, {
                id: this.queryId
              })
              .then(res => {
                if (res) {
                  this.form = res;
                  this.repairForm.repairDocumentId = this.form.id;
                }
              });
          }
        })
        .catch(error => {});
    },
    selectMember() {
      if (this.memberMsg != "") {
        this.$api
          .get(this.$url.member.search, {
            keyword: this.memberMsg,
            needIntegralFlag: true
          })
          .then(res => {
            if (res) {
              this.list = res.memberList[0];
              this.memberHide = true;
            } else {
              this.memberHide = false;
              this.$message.warning("没有找到此会员信息");
            }
          })
          .catch(error => {});
      } else {
        this.$message.warning("请输入客户手机号、编号或姓名");
      }
    },
    getFile(res) {
      this.repairForm.imgUrlList.push(res);
    },
    handleDelete(res) {
      this.repairForm.imgUrlList = res;
    },
    memberChange(value) {
      this.repairForm.memberId = value;
    },
    anewSubmit(item) {
      item.nextRepairTime = new Date(this.formatDay(item.repairTime));
      this.staffNames = item.staffIdCn;
      this.repairForm = item;
      this.$refs["handleEditForm"].$emit("set", this.repairForm);
    },
    saveMoney() {
      this.repairForm = {
        imgUrlList: [],
        remark: "",
        staffId: "",
        repairDocumentId: this.queryId,
        nextRepairTime: ""
      };
      // if (this.form.newDocumentFlag) {
      //新版
      this.$refs["handleEditForm"].$emit("set", {
        newDocumentFlag: this.form.newDocumentFlag,
        repairForm: this.repairForm
      });
      // } else {
      //   //老板
      //   this.$refs["handleEditForm"].$emit("set", this.repairForm);
      // }
      // if(this.repairForm.imgUrlList.length <= 0){
      //     this.$message.warning('请上传修护照片');
      //     return false;
      // }
      // if(this.status == -1){
      //     this.repairForm.nextRepairTime = -1;
      // } else {
      //     if(this.repairForm.nextRepairTime == ''){
      //         this.$message.warning('请选择下次修护时间');
      //         return false;
      //     }
      //     this.repairForm.nextRepairTime = this.formatDay(this.repairForm.nextRepairTime);
      // }
      // if(this.repairForm.staffId == ''){
      //     this.$message.warning('请选择技师');
      //     return false;
      // }
      // if(this.repairForm.remark == ''){
      //     this.$message.warning('请输入备注');
      //     return false;
      // }
      // this.$api.post(this.$url.repairRecord.save,this.repairForm)
      // .then( res => {
      //     if(res){
      //         this.dialogHide = false;
      //         this.$router.push({path:`/collectMoney/paperRepair/pay`,query:{id: this.form.id,repairStatus: this.form.repairStatus}});
      //     }
      // })
    },
    savePay(value) {
      if (value != "") {
        this.repairForm.payCheckType = value.payCheckType;
        this.repairForm.verifyCode = value.verifyCode;
        this.$api
          .post(this.$url.repairRecord.save, this.repairForm)
          .then(res => {
            if (res) {
              this.dialogHide = false;
              this.$router.push({
                path: `/collectMoney/paperRepair/pay`,
                query: {
                  id: this.form.id,
                  repairStatus: this.form.repairStatus
                }
              });
            }
          });
      } else {
        this.dialogHide = false;
      }
    },
    bandMemberCard() {
      this.memberSearchHide = true;
    }
  }
};
</script>

 <style scoped lang="less">
// .check-in .el-input-group__append{
//     background-color: #409EFF;
//     color: #fff;
// }
// .search-dialog .el-dialog{
//     height: 500px;
// }
// .search-dialog .memberMsg{
//     width: 400px;
// }
// .search-dialog .memberMsg .flex-row{
//     justify-content: space-between;
//     height: 40px;
//     align-items: center;
// }
// .search-dialog .memberMsg .flex-row p span{
//     color: red;
// }
</style>
<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  // .totals-box {
  //   padding: 0 0.2rem 0.2rem;
  //   font-size: 0.16rem;
  //   .boxs {
  //     .rows {
  //       display: flex;
  //       justify-content: space-between;
  //       margin-top: 20px;
  //       .name {
  //         width: 120px;
  //       }
  //     }
  //   }
  // }
  .totals-box {
    // padding: 0 0.2rem 0.2rem;
    // font-size: 0.16rem;
    .boxs {
      margin-top: 10px;
      background: #fff;
      .rows {
        padding: 0 20px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-top: 20px;
        border-bottom: 1px solid @borderColor;
        p {
          color: #383838;
        }
        .money {
          color: @money;
        }
        .name {
          width: 120px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .shop-boxs {
      margin-top: 0;
      .rows {
        height: 60px;
      }
    }
  }
  .repair-box {
    padding-bottom: 30px;
    margin-top: 10px;
    background: #fff;
    .repair-msg {
      border-top: 10px solid @borderColor;
    }
    &:last-child {
      .remarks-box {
        border-bottom: 1px solid @borderColor;
      }
    }
    .top {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      border-bottom: 1px solid #ebebeb;
      font-size: 16px;
      .name {
        display: flex;
      }
      .shop-img {
        width: 27px;
        margin-right: 10px;
      }
      .status {
        color: @blue;
      }
    }
    .center-mains {
      border-top: 10px solid @borderColor;
      //   padding: 0.2rem;
      color: #343434;
      .imgs-name {
        padding: 0 20px;
        margin-bottom: 15px;
        height: 60px;
        display: flex;
        font-weight: 500;
        align-items: center;
      }
      .imgs {
        border-bottom: 1px solid @borderColor;
        .img-list {
          padding: 0 20px;
        }
        .img {
          border-radius: 5px;
          margin: 0 20px 20px 0;
          width: 120px;
          height: 120px;
        }
      }
      .remarks-box {
        padding: 0 20px;
        border-bottom: 1px solid @borderColor;
        .remark {
          height: 60px;
          display: flex;
          align-items: center;
        }
        .text-area {
          margin-top: 7px;
          margin-bottom: 20px;
          /deep/ .el-textarea__inner {
            height: 76px;
          }
        }
      }
    }
  }
}

/deep/ .el-input-group__append {
  background-color: #409eff;
  color: #fff;
}
/deep/ .input-with-select {
  font-size: 0.18rem;
}
.isMember {
  // margin-bottom: .2rem;
  position: relative;
  .member-header {
    display: flex;
    align-items: center;
    width: 100%;
    .title-name {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      margin-right: 62px;
    }
    .icon-search {
      font-size: 0.3rem;
    }
  }
}
.member-box {
  width: calc(100% - 40px);
  height: 120px;
  position: absolute;
  top: 138px;
  left: 20px;
  z-index: 99;
  background: #fff;
  // box-shadow: 1px 1px 5px #bbb;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #646566;
    height: 120px;
    p {
      margin-bottom: 10px;
    }
    .bind-member-active {
      margin-top: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .history-box {
    padding: 10px;
  }
  .history-btn {
    margin-top: 10px;
    margin-left: 30px;
  }
}
.list {
  .flex-row {
    cursor: pointer;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    .msg {
      margin-left: 10px;
    }
    &:hover {
      background-color: #f1f1f1;
    }
  }
}
.member_bg {
  width: 100%;
  height: 56px;
  background-image: url("../../../assets/images/money/member_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  .flex-row {
    align-items: center;
    .img {
      width: 30px;
      height: 30px;
    }
  }
  .icons {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      color: @blue;
    }
  }
}
</style>
